import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import ActionLink from '../../../../components/ActionLink/ActionLink';
import CopyIcon from '../../../../components/Icons/ContentCopy/ContentCopy';

import { getString } from '../../../../helpers/stringHelpers';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'bankDetails';

function ReadOnlyBankField(props) {
  const { classes, bank, branch, accountNumber, suffix } = props;

  const renderNumbers = (numbers) => {
    return numbers.split('').map((number, i) => {
      return (
        <div className={classes.number} key={i}>
          <Typography component='span'>{number}</Typography>
        </div>
      );
    });
  };

  const renderGroup = (label, numbers) => {
    return (
      <div className={classes.group}>
        <Typography className={classes.label}>{label}</Typography>
        {renderNumbers(numbers)}
      </div>
    );
  };

  const copyBankAccountNumber = () => {
    navigator.clipboard.writeText(bank + branch + accountNumber + suffix);
  };

  return (
    <div className={classes.root}>
      <div className={classes.field}>
        <Hidden xsDown>
          {renderGroup(getString(stringsComponent, 'BANK_LABEL'), bank)}
          {renderGroup(getString(stringsComponent, 'BRANCH_LABEL'), branch)}
          {renderGroup(
            getString(stringsComponent, 'ACCOUNT_NUMBER_SHORT_LABEL'),
            accountNumber
          )}
          {renderGroup(getString(stringsComponent, 'SUFFIX_LABEL'), suffix)}
        </Hidden>
        <Hidden smUp>
          <Typography>
            {bank}-{branch}-{accountNumber}-{suffix}
          </Typography>
        </Hidden>
      </div>
      <Typography className={classes.copyLink}>
        <ActionLink
          label={getString(stringsComponent, 'COPY_LABEL')}
          action={copyBankAccountNumber}
          icon={CopyIcon}
        />
      </Typography>
    </div>
  );
}

ReadOnlyBankField.propTypes = {
  classes: PropTypes.object.isRequired,
  bank: PropTypes.string.isRequired,
  branch: PropTypes.string.isRequired,
  accountNumber: PropTypes.string.isRequired,
  suffix: PropTypes.string.isRequired,
};

ReadOnlyBankField.defaultProps = {};

export default withStyles(styles)(ReadOnlyBankField);
